import { useState, useEffect } from "react";

import BookAppointment from "./BookAppointment";

import doc1 from "../../assets/images/doc1.webp";
import doc2 from "../../assets/images/doc2.webp";
import doc3 from "../../assets/images/doc3.webp";
import doc4 from "../../assets/images/doc4.webp";
import doc5 from "../../assets/images/doc5.webp";
import doc6 from "../../assets/images/doc6.webp";
import doc7 from "../../assets/images/doc7.webp";
import doc8 from "../../assets/images/doc8.webp";
import defaultDocImg from "../../assets/images/doc1.webp";
import Lastmenu from "./Lastmenu";
import { getDoctors } from "../api/apiServices";

const IVFExperts = ({name: initialName, mobile: initialMobile}) => {
  const [doctors, setDoctors] = useState([]);
  const [name, setName] = useState(initialName || "");
  const [mobile, setMobile] = useState(initialMobile || "");
  const [index, setIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [selectedDoctorId, setSelectedDoctorId] = useState(null);
  const [showAppointmentFrame, setShowAppointmentFrame] = useState(false);

  const doctorImages = [doc1, doc2, doc3, doc4, doc5, doc6, doc7, doc8];

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const response = await getDoctors();
        if (response.status === 200) {
          setDoctors(response.data.doctors);
        } else {
          setError("Failed to fetch doctors.");
        }
      } catch (err) {
        setError("Server error: " + (err.response?.data?.detail || err.message));
      } finally {
        setLoading(false);
      }
    };
    fetchDoctors();
  }, []);

  const nextDoctor = () => {
    setIndex((prev) => (prev + 1) % doctors.length);
  };

  const prevDoctor = () => {
    setIndex((prev) => (prev - 1 + doctors.length) % doctors.length);
  };

  const handleShowFrame = (doctorId) => {
    setSelectedDoctorId(doctorId);
    setShowAppointmentFrame(true);
  };

  if (loading) {
    return (
      <div className="frame1 animated-frame">
        <h2 style={{ textAlign: "center", color: "#fe5631", marginTop: "-5px" }}>IVF Experts</h2>
        <div className="doctor-frame">
          <div className="image-container">
            <div className="skeleton-img skeleton-loader"></div>
          </div>
          <div className="description">
            <div className="skeleton-text skeleton-loader" style={{ width: "70%", height: "20px" }}></div>
            <div className="skeleton-text skeleton-loader" style={{ width: "50%", height: "16px" }}></div>
            <div className="skeleton-text skeleton-loader" style={{ width: "60%", height: "16px" }}></div>
            <div className="skeleton-text skeleton-loader" style={{ width: "40%", height: "16px" }}></div>
            <div className="skeleton-button skeleton-loader"></div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return <div className="frame1">❌ {error}</div>;
  }

  if (!doctors.length) {
    return <div className="frame1">No doctor data available</div>;
  }

  const current = doctors[index];
  const currentImage = doctorImages[index] || defaultDocImg;

  return (
    <>
      <div className="frame1 animated-frame">
        <h2 style={{ textAlign: "center", color: "#fe5631", marginTop: "-5px" }}>
          IVF Experts
        </h2>

        <div className="doctor-frame">
          <div className="image-container">
            <button className="arrow left" onClick={prevDoctor}>❮</button>
            <img src={currentImage} alt={current.name} className="doctor-img" />
            <button className="arrow right" onClick={nextDoctor}>❯</button>
          </div>

          <div className="description">
            <p style={{ color: "green" }}>
              <strong>✅{current.experience}</strong>
            </p>
            <h3>{current.name}</h3>
            <p><strong>Location:</strong> {current.location}</p>
            <p><strong>Specialization:</strong> {current.specialization}</p>
            <button className="detatils-button2" onClick={() => handleShowFrame(current.doctor_id)}>
              Book Appointment
            </button>
          </div>
        </div>
      </div>

      <Lastmenu />

      {showAppointmentFrame && selectedDoctorId && (
        <BookAppointment doctorId={selectedDoctorId} name={name} mobile={mobile}/>
      )}
    </>
  );
};

export default IVFExperts;
